"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextRenderer = void 0;
const compiler_1 = require("../text/compiler");
const capitalize_1 = require("../text/formatters/capitalize");
const conditional_1 = require("../text/formatters/conditional");
const for_each_1 = require("../text/formatters/for_each");
const indent_1 = require("../text/formatters/indent");
const is_empty_1 = require("../text/formatters/is_empty");
/**
 * Compiles the renderer for a TEXT-type template into a function.
 */
exports.TextRenderer = new compiler_1.Compiler({
    capitalize: () => new capitalize_1.Capitalize(),
    true: ([childRenderer]) => new conditional_1.Conditional(true, childRenderer),
    false: ([childRenderer]) => new conditional_1.Conditional(false, childRenderer),
    for_each: ([elementRenderer, separatorRenderer]) => new for_each_1.ForEach(elementRenderer, separatorRenderer === undefined ? '' : separatorRenderer.default({})),
    is_empty: ([childRenderer]) => new is_empty_1.IsEmpty(childRenderer),
    indent: ([indentRenderer]) => new indent_1.Indent(indentRenderer.default({})),
});
//# sourceMappingURL=text_renderer.js.map